// Sprint F · Feature 1 — workstream taxonomy.
//
// Hardcoded in v1 per the sprint plan (no admin UI for custom streams).
// Each saved site gets all 9 workstreams initialized to `not_started`.
// `site_screening` flips to `complete` automatically when the site has
// any enrichment data on it (proxy for "we ran the screening pipeline").

export const WORKSTREAMS = [
  { key: 'site_screening',  label: 'Site Screening', short: 'Screen' },
  { key: 'land_title',      label: 'Land & Title',   short: 'Land'   },
  { key: 'grid_connection', label: 'Grid Connection', short: 'Grid'   },
  { key: 'permitting',      label: 'Permitting',     short: 'Permit' },
  { key: 'geotechnical',    label: 'Geotechnical',   short: 'Geo'    },
  { key: 'environmental',   label: 'Environmental',  short: 'Env'    },
  { key: 'connectivity',    label: 'Connectivity',   short: 'Fiber'  },
  { key: 'construction',    label: 'Construction',   short: 'Constr' },
  { key: 'financing',       label: 'Financing',      short: 'Financ' },
];

export const WORKSTREAM_KEYS = WORKSTREAMS.map(w => w.key);

export const STATUS_DEFS = [
  { key: 'not_started', label: 'Not started',    icon: '⚪', color: '#475569' },
  { key: 'in_progress', label: 'In progress',    icon: '🔵', color: '#3b82f6' },
  { key: 'complete',    label: 'Complete',       icon: '✅', color: '#22c55e' },
  { key: 'attention',   label: 'Needs attention', icon: '🟡', color: '#f59e0b' },
  { key: 'blocked',     label: 'Blocked',        icon: '🔴', color: '#ef4444' },
  { key: 'na',          label: 'N/A',            icon: '➖', color: '#334155' },
];

export const STATUS_KEYS = STATUS_DEFS.map(s => s.key);

export function statusDef(key) {
  return STATUS_DEFS.find(s => s.key === key) || STATUS_DEFS[0];
}

// Empty workstream record — used when a site has no `workstreams` JSONB
// yet so the Timeline can still render its row.
export function emptyWorkstream(key) {
  return {
    key,
    status: 'not_started',
    owner_user_id: null,
    started_at: null,
    target_completion: null,
    actual_completion: null,
    notes: '',
    last_updated: null,
  };
}

// Normalize whatever's on a project (might be undefined, partial, or a
// full list) into the canonical 9-workstream array. Auto-derives
// site_screening = 'complete' when there's any enrichment data so newly
// saved sites don't show "not started" for screening they already passed.
export function normalizeWorkstreams(project) {
  const stored = Array.isArray(project?.workstreams) ? project.workstreams : [];
  const byKey = new Map(stored.map(w => [w.key, w]));
  const screenedAlready = !!(project?.enrichment && Object.keys(project.enrichment).length > 5);

  return WORKSTREAMS.map(({ key }) => {
    const existing = byKey.get(key);
    if (existing) return { ...emptyWorkstream(key), ...existing };
    const blank = emptyWorkstream(key);
    if (key === 'site_screening' && screenedAlready) {
      blank.status = 'complete';
      blank.actual_completion = project?.created_at || null;
    }
    return blank;
  });
}
